$(function(){ 

//scrole//
$('a[href^="#"]').click(function(event){
    event.preventDefault(); // デフォルトのリンク動作を無効化します
    var speed = 500; // スクロールのスピードを500ミリ秒に設定します
    var href = $(this).attr("href"); // クリックされたリンクのhref属性の値を取得します
    var target = $(href == "#" || href == "" ? 'html' : href); // リンク先の要素を取得します
    var position = target.offset().top - 0; // スクロール位置を設定します

    $("html, body").animate({scrollTop: position}, speed, "swing"); // スクロールアニメーションを実行します
    return false; // デフォルトのリンク動作を無効化します
});

//color-change//
$(document).on('click', ".slider_nav li", function(event){
    event.preventDefault();
    var index = $(this).index();
    var parent = $(this).closest(".product1");

    parent.find(".slider li").hide().removeClass("active");
    parent.find(".slider li").eq(index).show().addClass("active");

    parent.find(".slider_nav li").removeClass("active");
    $(this).addClass("active");
});
});
